import {FC, useEffect, useRef} from 'react';

import {InfinityScrollProps} from './types';

export const InfinityScroll: FC<InfinityScrollProps> = ({
  children,
  className,
  onLoadMore,
  loading,
}) => {
  const anchorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const anchor = anchorRef.current;
    if (!anchor) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !loading) {
        onLoadMore();
      }
    });

    observer.observe(anchor);

    return () => {
      observer.unobserve(anchor);
    };
  }, [loading, onLoadMore]);

  return (
    <div className={className}>
      {children}
      <div ref={anchorRef} />
    </div>
  );
};
